<mat-toolbar class="h-16 px-4 flex items-center justify-between">
  <div class="flex items-center space-x-2 flex-shrink-0">
    @if (isMobile && isAuthenticated && !hideHeader()) {
    <button mat-icon-button (click)="onToggleMenu()" aria-label="Toggle menu">
      <mat-icon>menu</mat-icon>
    </button>
    } @if (!isMobile && isAuthenticated) {
    <a (click)="navigateTo('calendar')">
      <img
        src="assets/logo/qualitime.png"
        [alt]="'imgAlt.logo' | transloco"
        class="h-10 cursor-pointer"
      />
    </a>
    }
  </div>

  <div class="flex justify-center items-center flex-grow">
    @if (isMobile || !isAuthenticated) {
    <a (click)="navigateTo('login')">
      <img
        src="assets/logo/qualitime.png"
        [alt]="'imgAlt.logo' | transloco"
        class="h-10 cursor-pointer"
      />
    </a>
    }
  </div>

  <div class="flex items-center space-x-2 flex-shrink-0">
    @if (isAuthenticated && !hideHeader() && headerData) {
    <img
      [src]="
        headerData!.picture ? headerData!.picture : (isAdmin() ? 'assets/img/avatar-admin.png' : 'assets/img/avatar.png')
      "
      alt="Avatar"
      class="w-[32px] h-[32px] rounded-full object-cover select-none"
      [class.admin-avatar-ring]="isAdmin() && headerData!.picture"
    />
    @if(headerData!.name && headerData!.surname){
    <span class="hidden sm:inline user-name">{{
      headerData!.name + " " + headerData!.surname | titlecase
    }}</span>
    }@else if (headerData!.name) {
    <span class="hidden sm:inline user-name">{{
      headerData!.name | titlecase
    }}</span>
    } }
  </div>
</mat-toolbar>
